// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"74af3438","3659":"a5df5307","3735":"fccd4750","8859":"1f2987e2","9289":"131da496"}[chunkId] + ".chunk.css";
};